<template>
  <div>
    <el-dialog
      :before-close="handleClose"
      :visible.sync="dialogVisible"
      append-to-body
      :close-on-press-escape="false" 
      :close-on-click-modal="false"
      :show-close="true">
      <div class="workflow-container" :class="{ 'readonly-mode': readonly }">
        <div class="top-title-container">{{workFlowTitle}}
            <el-button @click="dialogVisible =false"  type="primary" plain size="mini" style="height:29px;margin-top:3px;margin-left:100px; margin-right:10px">
                <i class="iconfont icon-shanchu" style=" font-size:12px;margin-right:3px"></i>退出
            </el-button>
            <el-button v-if="isWorkFlowView" @click="saveData" type="danger" plain size="mini" style="height:29px;margin-top:3px;margin-left:122px; ">
                <i class="iconfont icon-baocun" style=" font-size:12px;margin-right:3px"></i>保存流程
            </el-button>
            
             
        </div>
        <div class="approval-flow fd-nav-content">
          <div class="dingflow-design">
            
            <div id="box-scale" class="box-scale">
              <nodeWrap 
              :isWorkFlowView="isWorkFlowView"
              :dataFields="dataFields" 
              :nodeConfig="nodeConfig" 
              :readonly="readonly" 
              v-bind="$attrs"
              @starter-updated="handleStarterUpdated"
              @node-deleted="handleNodeDeleted"
              @nodes-deleted-batch="handleNodesDeletedBatch"
              ref="topNodeWrap"
              >
              </nodeWrap>
              <div class="end-node">
                <div class="end-node-circle"></div>
                <div class="end-node-text">流程结束</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="bottom-save-btn-container">
 
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {flattenProcessNode} from '@/utils/flattenProcessNode.js'
import nodeWrap from './nodeWrap.vue'

export default {
  components: {
    nodeWrap,
  },
  props: {
    workFlowTitle: {
      type: String,
      default: ''
    },
    dlgWidth: {
      type: String,
      default: ''
    },
    isWorkFlowView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      isTried: false,
      tipList: [],
      nodeConfig: {},
      deletedNodeIds: [],
      dataFields: [
        {name: "数量", key: "qty", type: "number"},
        {name: "金额", key: "amt", type: "number"} 
      ],
      nowVal: 100,
      flattenProcessList: [],
      readonly: false,
    };
  },
  created() {
    // 监听根组件中的workflow-node-deleted事件
    this.$root.$on('workflow-node-deleted', this.handleRootNodeDeleted);
    // 监听根组件中的workflow-nodes-deleted-batch事件
    this.$root.$on('workflow-nodes-deleted-batch', this.handleRootNodesDeletedBatch);
  },

  beforeDestroy() {
    // 移除事件监听，避免内存泄漏
    this.$root.$off('workflow-node-deleted', this.handleRootNodeDeleted);
    this.$root.$off('workflow-nodes-deleted-batch', this.handleRootNodesDeletedBatch);
  },

  methods: {
    // 处理从根组件接收到的节点删除事件
    handleRootNodeDeleted(nodeDbId) {
      this.handleNodeDeleted(nodeDbId);
    },
    
    // 处理从根组件接收到的批量节点删除事件
    handleRootNodesDeletedBatch(nodeIds) {
      this.handleNodesDeletedBatch(nodeIds);
    },
    
    // 处理批量节点删除事件
    handleNodesDeletedBatch(nodeIds) {
      if (Array.isArray(nodeIds) && nodeIds.length > 0) {
        // 合并数组并去重
        this.deletedNodeIds = [...new Set([...this.deletedNodeIds, ...nodeIds])];
      }
    },

    // 打开弹窗并初始化数据
    open(mode, data, readonly = false) {
      // 打开弹窗时重置状态
      this.isTried = false;
      this.tipList = [];
      this.flattenProcessList = [];
      this.nowVal = 100;
      
      // 尝试从localStorage恢复之前存储的删除节点ID
      try {
        const workflowId = (data && data.IDSEQ) || 'temp';
        const storageKey = `workflow_deleted_nodes_${workflowId}`;
        const savedIds = localStorage.getItem(storageKey);
        if (savedIds) {
          this.deletedNodeIds = JSON.parse(savedIds);
        } else {
          this.deletedNodeIds = []; // 没有找到存储的ID，重置数组
        }
      } catch (e) {
        this.deletedNodeIds = []; // 出错时重置数组
      }
      
      this.dialogVisible = true;
      this.mode = mode;
      
      if (mode === 'add') {
        // 添加模式，设置默认发起人节点
        this.nodeConfig = {
          nodeName: "发起人",
          type: 0,
          priorityLevel: "",
          conditionString: "",
          conditionStringName: "",
          preId: "",
          error: false,
          nodeUserType: {
            valueName: "所有人",
            valueList: [],
            type: "ALL",
            value: ""
          },
          nodeId: "",
          childNode: {
            nodeName: "审核人",
            error: false,
            nodeUserType: {
              nodeName: "",
              valueName: "",
              valueList: [],
              type: "",
              value: ""
            },
            examineMode: "1",
            type: 1,
            nodeId: ""
          }
        }
      } else if (mode === 'edit') {
        console.log('data',data);
        
        // 编辑模式下深拷贝传入数据，避免污染原引用
        this.nodeConfig = JSON.parse(JSON.stringify(data));
        if (this.nodeConfig) {
          // 递归检查所有节点是否有IDSEQ
          this.checkNodeIds(this.nodeConfig);
        }
      } else {
        // 查看模式直接赋值
        this.nodeConfig = data;
      }
      
      // 设置只读状态，可以通过参数传入，或者为查看模式时启用
      this.readonly = readonly || mode === 'show';
      this.dialogVisible = true;
    },

    // 递归检查节点ID
    checkNodeIds(node, level = 0) {
      if (!node) return;
      
      // 检查子节点
      if (node.childNode) {
        this.checkNodeIds(node.childNode, level + 1);
      }
      
      // 检查条件节点
      if (node.conditionNodes && node.conditionNodes.length > 0) {
        node.conditionNodes.forEach((condNode, index) => {
          this.checkNodeIds(condNode, level + 1);
        });
      }
    },

    // 关闭弹窗处理
    handleClose() {
      this.dialogVisible = false
    },

    // 处理发起人更新事件
    handleStarterUpdated(starterConfig) {
      if (this.nodeConfig && this.nodeConfig.type === 0) {
        const newNodeUserType = JSON.parse(JSON.stringify(starterConfig.nodeUserType));
        this.$set(this.nodeConfig, 'nodeUserType', newNodeUserType);
        this.$forceUpdate();
      }
    },

    // 处理节点删除事件
    handleNodeDeleted(nodeDbId) {
      if (nodeDbId && !this.deletedNodeIds.includes(nodeDbId)) {
        this.deletedNodeIds.push(nodeDbId);
      }
    },

    // 保存
    saveData() {
      // 收集顶层节点包装器组件中的所有被删除节点ID
      if (this.$refs.topNodeWrap && typeof this.$refs.topNodeWrap.collectDeletedNodeIds === 'function') {
        const childDeletedIds = this.$refs.topNodeWrap.collectDeletedNodeIds();
        if (childDeletedIds && childDeletedIds.length > 0) {
          this.deletedNodeIds = [...new Set([...this.deletedNodeIds, ...childDeletedIds])];
        }
      }
      
      this.tipList = []
      this.dialogVisible = false
      
      // 保存成功后清除localStorage中的临时数据
      try {
        const workflowId = this.nodeConfig.IDSEQ || 'temp';
        const storageKey = `workflow_deleted_nodes_${workflowId}`;
        localStorage.removeItem(storageKey);
      } catch (e) {
        // 忽略错误
      }
      
      // 将节点配置和被删除节点ID一起传递给父组件
      this.$emit('saveWorkflow', this.nodeConfig, this.deletedNodeIds);
      // 保存后重置deletedNodeIds数组
      this.deletedNodeIds = [];
    },

    reErr(data) {
      if (data.childNode) {
        if (data.childNode.type == 0) {
          //选择人
          if (data.childNode.error) {
            this.tipList.push({
              name: data.childNode.nodeName,
              type: '选择人',
            })
          }
          this.reErr(data.childNode)
        } else if (data.childNode.type == 1) {
          if (data.childNode.error) {
            this.tipList.push({
              name: data.childNode.nodeName,
              type: '审核人',
            })
          }
          this.reErr(data.childNode)
        } else if (data.childNode.type == 2) {
          if (data.childNode.error) {
            this.tipList.push({
              name: data.childNode.nodeName,
              type: '抄送人',
            })
          }
          this.reErr(data.childNode)
        } else if (data.childNode.type == 3) {
          this.reErr(data.childNode.childNode)
        } else if (data.childNode.type == 4) {
          this.reErr(data.childNode)
          for (
            var i = 0; i < data.childNode.conditionNodes.length; i++
          ) {
            if (data.childNode.conditionNodes[i].error) {
              this.tipList.push({
                name: data.childNode.conditionNodes[i].nodeName,
                type: '条件',
              })
            }
            this.reErr(data.childNode.conditionNodes[i])
          }
        }
      } else {
        data.childNode = null
      }
    },

    zoomSize(type) {
      if (type == 1) {
        if (this.nowVal == 50) {
          return;
        }
        this.nowVal -= 10;
      } else {
        if (this.nowVal == 300) {
          return;
        }
        this.nowVal += 10;
      }
    },

    // 获取流程数据
    getData() {
      return {
        processNode: this.flattenProcessList,
        nodeConfig: this.nodeConfig
      };
    },

    // 验证工作流
    validateWorkflow() {
      return new Promise((resolve, reject) => {
        // 扁平化流程节点
        this.flattenProcessList = flattenProcessNode(this.nodeConfig);
        this.tipList = [];

        // 检查流程
        this.reErr(this.nodeConfig);

        if (this.tipList.length > 0) {
          // 有错误
          reject(this.tipList);
        } else {
          // 验证通过
          resolve(true);
        }
      });
    },
  },
};
</script>
<style>
@import "./css/workflow.css";

.error-modal-list {
  width: 455px;
}

.fixed-save-btn {
  position: fixed;
  top: 20px;
  right: 30px;
  z-index: 3000;
}

.bottom-save-btn-container {
  position: fixed;
  bottom: 20px;
  left: 80px;
  right: 20px;
  height:35px;
  text-align: right;
  background: #ccc;
  z-index: 3000;
}
.top-title-container {
  position: fixed;
  top: 30px;
  left: 80px;
  right: 20px;
  height:35px;
  line-height:35px;
  color:rgb(59, 45, 45);
  padding-left:10px;
  border-left:5px solid #f00;
  font-size:14px;
  font-weight:600;
  text-align: left;
  background: rgb(145, 185, 238);
  display:flex;
  z-index: 3000;
}
/* 只在节点内部禁用交互，但保留滚动条 */
.workflow-container.readonly-mode .node-wrap,
.workflow-container.readonly-mode .branch-wrap {
  pointer-events: none;
}
/* 隐藏节点删除、添加等按钮 */
.workflow-container.readonly-mode .el-icon-close,
.workflow-container.readonly-mode .add-branch,
.workflow-container.readonly-mode .el-icon-plus {
  display: none;
}
</style>
<style scoped lang="less">
  .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
